const initialState = {
  created: null,
  lifespan: 0,
  version: null,
  fingerprint: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'SET_SESSION_FIELD':
      return { ...state, ...action.payload };
    case 'SET_TOKEN_CREATED':
      return { ...state, created: action.payload };
    case 'SET_TOKEN_LIFESPAN':
      return { ...state, lifespan: action.payload };
    case 'SET_FINGERPRINT':
      return { ...state, fingerprint: action.payload };
    case 'UPDATE_VERSION':
      return { ...state, version: action.payload };
    case 'CLEAR_SESSION':
      return initialState;
    case 'CLEAR':
      return initialState;
    default:
      return state;
  }
}
